import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { LocalStorageService } from "../../services/local-storage.service";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { IAppState } from "../../store/state/app.state";
import { iconsLibrary } from "../../../theme/constants";
import { CoworkingService } from "../../services/coworking.service";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { Router } from "@angular/router";
import * as moment from "moment";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import { StateService } from "../../services/state.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Validators } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { CoworkerService } from "../../services/coworker.service";
import { CompanyService } from "../../services/company.service";
import { EButtonType } from "../../data-types/button.enum";
@Component({
  selector: "cowing-core-employees-home",
  templateUrl: "./company-home-employees.component.html",
  styleUrls: ["./company-home-employees.component.scss"],
})
export class CompanyHomeEmployeesComponent implements OnInit, OnDestroy {
  public EFooterStyleInput = EFooterStyleInput;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public companyId;
  public employeesList = [];
  public filterSpacesList = [];
  public bookingStates = [];
  public nextPage = null;
  public previousPage = null;
  newEmployee = false;
  iconsLibrary;
  essentialsServices;
  othersServices;
  allSpaces;
  subscription = new Subscription();
  filterForm: FormGroup;
  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    moment.locale("es");
    this.filterForm = this.formBuilder.group({
      space_id: new FormControl(null),
      state_id: new FormControl(null),
      page: new FormControl(0),
    });
  }

  async ngOnInit() {
    this.subscription.add(
      CompanyService.instance.companyModified.subscribe(async () => {
        try {
          this.employeesList = [];
          this._store.dispatch(showLoadingAction({}));

          await this.getEmployees();
        } catch (e) {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message:
                  e.status === 401
                    ? this.translate.instant("general.expired")
                    : e.data.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
        } finally {
          this._store.dispatch(closeLoadingAction({}));
        }
      })
    );
    // this.subscription.add(
    //   CompanyService.instance.coworkingStatusModified.subscribe(
    //     async (value) => {
    //       try {
    //         this.bookingsList = [];
    //         this._store.dispatch(showLoadingAction({}));

    //         await this.getBookings();
    //       } catch (e) {
    //         this._store.dispatch(
    //           showAlertAction({
    //             payload: {
    //               message: e.error,
    //               title: this.translate.instant("general.caution"),
    //               type: "error",
    //             },
    //           })
    //         );
    //       } finally {
    //         this._store.dispatch(closeLoadingAction({}));
    //       }
    //     }
    //   )
    // );
    this.subscription.add(
      this.filterForm.valueChanges.subscribe(async (newValue) => {
        //   try {
        //     this.bookingsList = [];
        //     this._store.dispatch(showLoadingAction({}));
        //     await this.getBookings();
        //   } catch (e) {
        //     this._store.dispatch(
        //       showAlertAction({
        //         payload: {
        //           message: e.error,
        //           title: this.translate.instant("general.caution"),
        //           type: "error",
        //         },
        //       })
        //     );
        //   } finally {
        //     this._store.dispatch(closeLoadingAction({}));
        //   }
      })
    );
    this.subscription.add(
      CompanyService.instance.newCompanySelected.subscribe(async (newValue) => {
        this.companyId = newValue;
        try {
          this.employeesList = [];
          this._store.dispatch(showLoadingAction({}));

          await this.getEmployees();
        } catch (e) {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message:
                  e.status === 401
                    ? this.translate.instant("general.expired")
                    : e.data.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
        } finally {
          this._store.dispatch(closeLoadingAction({}));
        }
      })
    );
    this.companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this._store.dispatch(showLoadingAction({}));
    try {
      await this.getEmployees();
    } catch (e) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message:
              e.status === 401
                ? this.translate.instant("general.expired")
                : e.data.error,
            title: this.translate.instant("general.caution"),
            type: "error",
          },
        })
      );
    } finally {
      this._store.dispatch(closeLoadingAction({}));
    }
  }

  get getCalendarIcon() {
    return `${iconsLibrary.calendarEmpty}`;
  }

  public async getEmployees() {
    const employees = await CompanyService.instance.getCompanyEmployees(
      this.companyId
      // {
      //   space_id: this.filterForm.get("space_id").value,
      //   state_id: this.filterForm.get("state_id").value,
      //   pagination: {
      //     page: this.filterForm.get("page").value,
      //   },
      // }
    );
    // this.nextPage = employees.pagination.next_page;
    // this.previousPage = employees.pagination.previous_page;
    this.employeesList = employees;
    return employees;
  }

  toggleModal(e) {
    this.newEmployee = e;
  }

  public deleteEmployee(employee) {
    this._store.dispatch(
      showAlertAction({
        payload: {
          message: "",
          title: "Â¿Desea eliminar este empleado?",
          type: "deleteEmployee",
          employeeId: employee.id,
        },
      })
    );
  }
  public async getSpaces() {
    // const spaces = await CoworkingService.instance.getCoworkingSpaces(
    //   this.coworkingId
    // );
    // this.filterSpacesList = spaces.map((space) => {
    //   return {
    //     id: space.id,
    //     name: space.name,
    //   };
    // });
    // this.filterSpacesList.push({ id: null, name: "Todos" });
    // return spaces;
  }

  public get getTrashIcon() {
    return `${iconsLibrary["trashActive"]}`;
  }
  private navigateTo(link) {
    this.router.navigate([link]);
  }
  public get getLeftArrowIcon() {
    return `${iconsLibrary["leftArrowTable"]}`;
  }
  public get getRightArrowIcon() {
    return `${iconsLibrary["rightArrowTable"]}`;
  }

  public get getDisabledLeftArrowIcon() {
    return `${iconsLibrary["disabledLeftArrowTable"]}`;
  }
  public get getDisabledRightArrowIcon() {
    return `${iconsLibrary["disabledRightArrowTable"]}`;
  }
  public get getTodayDate() {
    return `Hoy, ${moment().format("DD/MMMM/yyyy")}`;
  }

  public setNextPage() {
    // if(this.filterForm.get('page').value !== bookings.pagination.current_page) {
    this.filterForm.get("page").setValue(this.filterForm.get("page").value + 1);
    // }
  }
  public setPreviousPage() {
    // if(this.filterForm.get('page').value !== bookings.pagination.current_page) {
    this.filterForm.get("page").setValue(this.filterForm.get("page").value - 1);
    // }
  }
  public editSpaces() {
    this.navigateTo("coworking-spaces");
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
